import React, { Fragment } from 'react';
import { Header, Card, Button } from 'semantic-ui-react';
import Img from 'react-image';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import LazyLoad from 'react-lazyload';
import { useMediaQuery } from 'react-responsive';

const EventPhotos = ({
  event,
  deletePhoto,
  setMainPhoto,
  photos,
  loading,
  elementName
}) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 1001px)'
  });

  let filteredPhotos;
  if (photos) {
    filteredPhotos = photos.filter(photo => {
      return photo.url !== event.eventPhotoURL;
    });
  }
  return (
    <Fragment>
      <Header
        sub
        color="teal"
        content="All Photos"
        style={{
          marginTop: '-9px',
          marginBottom: isDesktopOrLaptop ? '9px' : '23px'
        }}
      />
      <Card.Group stackable itemsPerRow={2}>
        <LazyLoad height={210}>
          <Card>
            <Img
              src={event.eventPhotoURL}
              loader={<LoadingComponent />}
              unloader={<span>Image not found</span>}
              style={{ width: '100%' }}
            />

            <Button positive style={{ marginTop: '5px' }}>
              Main Photo
            </Button>
          </Card>
        </LazyLoad>
        {photos &&
          filteredPhotos.map((photo, index) => (
            <LazyLoad key={index} height={210}>
              <Card>
                <Img
                  src={photo.url}
                  loader={<LoadingComponent />}
                  unloader={<span>Image not found</span>}
                  style={{ width: '100%' }}
                />

                <div className="ui two buttons">
                  <Button
                    name={photo.id}
                    style={{ marginTop: '5px' }}
                    loading={loading && elementName === photo.id}
                    onClick={() => setMainPhoto(photo, event.id, photo.id)}
                    basic
                    color="green"
                  >
                    Main
                  </Button>
                  <Button
                    name={photo.name}
                    loading={loading && photo.name === elementName}
                    style={{ marginTop: '5px' }}
                    onClick={() => deletePhoto(photo, event.id)}
                    basic
                    icon="trash"
                    color="red"
                  />
                </div>
              </Card>
            </LazyLoad>
          ))}
      </Card.Group>
    </Fragment>
  );
};

export default EventPhotos;
